import React, { useEffect, useState } from "react";

const SOURCES = {
  cgp: "/logos/cgp-logo-reveal.svg",
  ripper: "/logos/ripper-logo-reveal.svg",
};

const cache = {};

function loadLogo(variant) {
  if (cache[variant]) return Promise.resolve(cache[variant]);
  return fetch(SOURCES[variant])
    .then((response) => response.text())
    .then((text) => {
      cache[variant] = text;
      return text;
    });
}

export default function HeaderWordmark({ variant }) {
  const [logos, setLogos] = useState({ ...cache });

  useEffect(() => {
    let cancel = false;

    Promise.all(
      Object.keys(SOURCES).map(async (key) => [key, await loadLogo(key)]),
    ).then((entries) => {
      if (!cancel) setLogos(Object.fromEntries(entries));
    });

    return () => {
      cancel = true;
    };
  }, []);

  const svg = logos[variant];

  if (!svg) {
    return (
      <img
        src={variant === "ripper" ? "/3dripper.png" : "/cgp_logo_app.png"}
        alt=""
        style={
          variant === "ripper"
            ? { width: 168, height: "auto" }
            : { height: 56, width: "auto" }
        }
      />
    );
  }

  return (
    <div
      key={variant}
      className="app-wordmark"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
